import React, {useMemo} from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import Step from '@components/PageStep';
import {EBlockPosition, EComponent} from '@redux/types';
import MainContacts from '@components/MainContacts';
import ReviewsGrid from '@components/ReviewsGrid';
import {IReviewsItem, ITranslation} from '@common/types';
import DetailPageHeader from '@components/DetailPageHeader';
import {useTranslation} from '@common/hooks/useTranslation';
import {useGetMainStepCount} from '@common/hooks/useGetMainStepCount';


export const ServiceDetail = () => {
  const t = useTranslation('components') as ITranslation['components'];
  const {service} = useTypedSelector(state => state.services);
  const mainStepCount = useGetMainStepCount(service?.steps || []);
  const reviewsStepNumber = useMemo(() => mainStepCount + 1, [mainStepCount]);
  const contactStepNumber = useMemo(() => mainStepCount + (!!service?.feedbacks.length ? 2 : 1),
    [mainStepCount, service]);

  const reviews = useMemo(() => service?.feedbacks?.map((f) => {
    const r = f.review
    return {
      title: r.description,
      description: r.companyName,
      customer: r.customer,
      color: f?.color ?? r.color,
      cardType: f?.cardType ?? r.cardType,
      preview: r.preview
    }
  }) as IReviewsItem[] || [], [service])

  return (
    <>
      <DetailPageHeader {...service?.detail}/>

      {service?.steps?.map((item, index) => (
        <Step
          key={`step_${index}`}
          count={item.count}
          step={item.step}
          stepChildren={item.children}
        />
      ))}

      {!!service?.feedbacks.length && (
        <Step
          count={reviewsStepNumber}
          classNames={["review"]}
          step={{
            __component: EComponent.STEP,
            name: t.detail.reviews,
            displayStepNumber: true,
            childPosition: EBlockPosition.outsideStep
          }}
        >
          <ReviewsGrid
            type="reviews"
            reviews={reviews}
          />
        </Step>
      )}

      <Step
        classNames={["contacts"]}
        count={contactStepNumber}
        step={{
          __component: EComponent.STEP,
          name: t.detail.cooperation || '',
          displayStepNumber: true,
          childPosition: EBlockPosition.outsideStep
        }}
      >
        <MainContacts withPadding={false} customContacts={service?.contacts}/>
      </Step>
    </>
  )
}
